import { render, staticRenderFns } from "./FamousPediaInform.vue?vue&type=template&id=61994d4e&"
import script from "./FamousPediaInform.vue?vue&type=script&lang=js&"
export * from "./FamousPediaInform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports